// import { store } from '@/store'
import { defineStore } from 'pinia'

// 定义用户信息接口
interface UserInfo {
  [key: string]: any // 根据实际用户信息字段定义，这里使用索引签名作为临时方案
}

// 定义 UserStore 状态接口
interface UserStoreState {
  userInfo: UserInfo
  isLogin: boolean
}

// 定义 UserStore 的 getters
interface UserStoreGetters {
  getUser: UserInfo
  getIsLogin: boolean
}

// 定义 UserStore 的 actions
interface UserStoreActions {
  setUserInfo(data: UserInfo): void
  logout(): void
}

export const useUserStore = defineStore<'user', UserStoreState, UserStoreGetters, UserStoreActions>('user', {
  state: (): UserStoreState => {
    return {
      userInfo: {},
      isLogin: false,
    }
  },
  
  getters: {
    getUser(): UserInfo {
      return this.userInfo
    },
    getIsLogin(): boolean {
      return this.isLogin
    }
  },
  
  actions: {
    setUserInfo(data: UserInfo): void {
      this.userInfo = data
      this.isLogin = true
    },
    
    logout(): void {
      this.userInfo = {}
      this.isLogin = false
    },
  },
  
    // 持久化配置
  persist: {
    // 存储方式，默认为 localStorage
    storage: localStorage,
    
    // 持久化字段，只保存特定字段
    pick: ['userInfo', 'isLogin'],
    
    // 或者使用 omit 排除不保存的字段
    // omit: ['someTemporaryField'],
    
    // 自定义存储的 key
    key: 'user',
  }
})

// export const useAppStoreWithOut = () => {
//   return useUserStore(store)
// }